import React from 'react'
import slug from 'slug'
import { Text, HeadingWithAnchor as Heading, Box } from 'components'
import compileMarkdown from 'lib/compileMarkdown'

const BlurbSection = ({ blurb, ...rest }) => {
  if (!blurb || blurb.draft) return null
  return (
    <Box {...rest}>
      <Text is="div" mt={3}>
        <Heading id={blurb.slug ||slug(blurb.title)} is="h2">{blurb.title}</Heading>
        {compileMarkdown(blurb.body).tree}
      </Text>
    </Box>
  )
}

export default BlurbSection



// WEBPACK FOOTER //
// /opt/build/repo/src/components/BlurbSection.js